import { GuidelineDialog } from './GuidelineDialog';

// SearchSoftTagGuideline: Shows guidelines for searching soft tags
export const SearchSoftTagGuideline = () => (
  <GuidelineDialog
    title="Search Soft Tag Guideline"
    icon="Info"
    iconSize="xs"
    triggerTitle="Search SoftTag Guideline"
    content={
      <>
        Optional field, search tags from assets API <br />
        Search Example: CO2
      </>
    }
  />
);
